export enum ScrollDirection {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
